// src/extenders/audio-player.js
var AudioPlayer = class extends HTMLElement {
  constructor() {
    super();
    const audio = document.getElementById("audio");
    const playPauseButton = document.getElementById("play-pause-button");
    const volumeControl = document.getElementById("volume-control");
    const progressBar = document.getElementById("progress-bar");
    const currentTimeDisplay = document.getElementById("current-time");
    const totalTimeDisplay = document.getElementById("total-time");
    let isPlaying = false;
    playPauseButton.addEventListener("click", () => {
      if (isPlaying) {
        audio.pause();
        playPauseButton.innerHTML = `<svg
            xmlns:dc='http://purl.org/dc/elements/1.1/'
            xmlns:cc='http://creativecommons.org/ns#'
            xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns#'
            xmlns:svg='http://www.w3.org/2000/svg'
            xmlns='http://www.w3.org/2000/svg'
            xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'
            xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'
            version='1.1'
            id='Layer_1'
            width='460.5'
            height='531.74'
            viewBox='0 0 460.5 531.74'
            overflow='visible'
            enable-background='new 0 0 460.5 531.74'
            xml:space='preserve'
            inkscape:version='0.91 r13725'
            sodipodi:docname='TriangleArrow-White-Right.svg'
            class='w-3 h-3 translate-x-[2px]'
          >
            <metadata
            id="metadata4758"><rdf:RDF><cc:Work
                rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
                  rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work></rdf:RDF></metadata><defs
            id="defs4756" /><sodipodi:namedview
            pagecolor="#FFFFFF"
            bordercolor="#FFFFFF"
            borderopacity="1"
            objecttolerance="10"
            gridtolerance="10"
            guidetolerance="10"
            inkscape:pageopacity="0"
            inkscape:pageshadow="2"
            inkscape:window-width="1554"
            inkscape:window-height="987"
            id="namedview4754"
            showgrid="false"
            inkscape:zoom="1.2553293"
            inkscape:cx="284.0036"
            inkscape:cy="302.86649"
            inkscape:window-x="0"
            inkscape:window-y="0"
            inkscape:window-maximized="1"
            inkscape:current-layer="Layer_1" /><polygon
            points="1,265.87 460,0.866 460,530.874 "
            id="polygon4752"
            style="fill:#FFFFFF;stroke:#FFFFFF;stroke-opacity:1"
            transform="matrix(-1,0,0,1,460.5,0)" />
          </svg>`;
      } else {
        audio.play();
        playPauseButton.innerHTML = `<svg
            width='800px'
            height='800px'
            viewBox='0 0 48 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            class='w-3 h-3'
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"/>
      
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
      
            <g id="SVGRepo_iconCarrier"> <rect width="48" height="48" fill="white" fill-opacity="0.01"/> <path d="M16 12V36" stroke="#FFFFFF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/> <path d="M32 12V36" stroke="#FFFFFF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/> </g>
          </svg>`;
      }
      isPlaying = !isPlaying;
    });
    volumeControl.addEventListener("input", () => {
      audio.volume = volumeControl.value;
    });
    audio.addEventListener("timeupdate", () => {
      const currentTime = audio.currentTime;
      const duration = audio.duration;
      const currentMinutes = Math.floor(currentTime / 60);
      const currentSeconds = Math.floor(currentTime % 60);
      const totalMinutes = Math.floor(duration / 60);
      const totalSeconds = Math.floor(duration % 60);
      currentTimeDisplay.textContent = `${currentMinutes}:${currentSeconds < 10 ? "0" : ""}${currentSeconds}`;
      totalTimeDisplay.textContent = `${totalMinutes}:${totalSeconds < 10 ? "0" : ""}${totalSeconds}`;
      const progress = currentTime / duration * 100;
      progressBar.style.width = `${progress}%`;
    });
  }
};
if (!customElements.get("audio-player")) {
  customElements.define("audio-player", AudioPlayer);
}
